import { render, staticRenderFns } from "./ContactInfoPriceRules.vue?vue&type=template&id=8aa6cc20"
import script from "./ContactInfoPriceRules.vue?vue&type=script&lang=ts"
export * from "./ContactInfoPriceRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aa6cc20')) {
      api.createRecord('8aa6cc20', component.options)
    } else {
      api.reload('8aa6cc20', component.options)
    }
    module.hot.accept("./ContactInfoPriceRules.vue?vue&type=template&id=8aa6cc20", function () {
      api.rerender('8aa6cc20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoPriceRules.vue"
export default component.exports